import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import PropertyCardContext from '@components/PropertyCard/PropertyCardContext';
import { ProgressBarContainer } from './ProgressBar.style';
const ProgressBar = ({ progress }) => {
    const { isCardSelected } = useContext(PropertyCardContext);
    return (_jsx(ProgressBarContainer, { isCardSelected: isCardSelected, progress: progress, children: _jsx("div", { "data-testid": "progress-bar-fill" }) }));
};
export default ProgressBar;
